import { Component, input, inject, signal, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { UIRouterGlobals } from '@uirouter/angular';
import { OpPrimarySidebarToggle } from '../opPrimarySidebarToggle/opPrimarySidebarToggle.component';
import { OpLogoSelector } from '../opLogoSelector/opLogoSelector.component';
import { OpEnvironmentWarning } from '../opEnvironmentWarning/opEnvironmentWarning.component';
import { OpPrimarySidebarService } from '../opPrimarySidebar/opPrimarySidebar.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EmSidebarMode, EmSidebarPosition } from '@everymundo/em-cms-kit/emSidebar';
import { ProsAiButton } from 'app/components/prosAiChat/prosAiButton.component';

@Component({
  selector: 'op-header',
  templateUrl: './opHeader.view.html',
  styleUrls: ["./opHeader.style.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    OpPrimarySidebarToggle,
    OpLogoSelector,
    OpEnvironmentWarning,
    ProsAiButton
  ]
})
export class OpHeader {

  private $globals = inject(UIRouterGlobals);
  private _sidebar = inject(OpPrimarySidebarService);

  protected showPrimaryToggle = signal(true);
  protected primaryToggleToLeft = signal(true);
  protected currentApp: string = this.$globals.current.data?.app || "airtrfx";
  protected showAiButton = signal(false);
  protected aiButtonFlowName = signal("");
  protected aiButtonContext = signal<{ [k: string]: any }>({});
  protected aiButtonsSuggestions = signal<string[]>([]);

  constructor() {
    this._sidebar.change.pipe(takeUntilDestroyed())
      .subscribe(v => {
        this.showPrimaryToggle.set(v.mode != EmSidebarMode.Slim);
        this.primaryToggleToLeft.set(v.position == EmSidebarPosition.Left ? true : false);
        this.showAiButton.set(v.aiButton ? true : false);
        this.aiButtonFlowName.set(v.aiButtonFlow || "");
        this.aiButtonContext.set(v.aiButtonContext || {});
        this.aiButtonsSuggestions.set(v.aiButtonSuggested || []);
      })
  }
}

@Component({
  selector: "op-header-item",
  template: `
    <span class="uk-navbar-item">
      <ng-content></ng-content>
    </span>
  `
})
export class OpHeaderItem {

  @HostBinding("class.uk-visible@m")
  public get __hiddenSmall () {
    return this.hiddenSmall()
  }

  public hiddenSmall = input(false, {
    transform: (value: string | boolean) => (value != null && value !== false && `${value}` !== 'false')
  })
}
